/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_KoreanInputs */

const en_speechmatics_target_language_korean = /** @type {(inputs: Speechmatics_Target_Language_KoreanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korean`)
};

const fr_speechmatics_target_language_korean = /** @type {(inputs: Speechmatics_Target_Language_KoreanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coreen`)
};

const de_speechmatics_target_language_korean = /** @type {(inputs: Speechmatics_Target_Language_KoreanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koreanisch`)
};

const it_speechmatics_target_language_korean = /** @type {(inputs: Speechmatics_Target_Language_KoreanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`coreano`)
};

const ru_speechmatics_target_language_korean = /** @type {(inputs: Speechmatics_Target_Language_KoreanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`корейский`)
};

const es_speechmatics_target_language_korean = /** @type {(inputs: Speechmatics_Target_Language_KoreanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`coreano`)
};

const zh_cn2_speechmatics_target_language_korean = /** @type {(inputs: Speechmatics_Target_Language_KoreanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`韩国人`)
};

const ja_speechmatics_target_language_korean = /** @type {(inputs: Speechmatics_Target_Language_KoreanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`韓国語`)
};

const hi_speechmatics_target_language_korean = /** @type {(inputs: Speechmatics_Target_Language_KoreanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोरियाई`)
};

const pt_pt2_speechmatics_target_language_korean = /** @type {(inputs: Speechmatics_Target_Language_KoreanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`coreano`)
};

/**
* | output |
* | --- |
* | "Korean" |
*
* @param {Speechmatics_Target_Language_KoreanInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_korean = /** @type {((inputs?: Speechmatics_Target_Language_KoreanInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_KoreanInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_korean(inputs)
	if (locale === "de") return de_speechmatics_target_language_korean(inputs)
	if (locale === "it") return it_speechmatics_target_language_korean(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_korean(inputs)
	if (locale === "es") return es_speechmatics_target_language_korean(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_korean(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_korean(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_korean(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_korean(inputs)
	return en_speechmatics_target_language_korean(inputs)
});